
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="结合懒加载" fileName="combine-lazy-load.md" />
        <p>有些场景由于网络带宽或者请求限制每次只能分页请求数据，但又希望使用虚拟滚动提高渲染性能，这时你可以通过 <code>scrolling</code>实现虚拟滚动和懒加载的功能。以下为模拟数据，具体根据实际请求为准</p>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;ve-table
            :max-height=&quot;500&quot;
            :virtual-scroll-option=&quot;virtualScrollOption&quot;
            :columns=&quot;columns&quot;
            :table-data=&quot;tableData&quot;
            row-key-field-name=&quot;rowKey&quot;
        /&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    import { debounce } from &quot;lodash&quot;;
    export default {
        data() {
            return {
                virtualScrollOption: {
                    enable: true,
                    scrolling: this.scrolling,
                },
                columns: [
                    {
                        field: &quot;index&quot;,
                        key: &quot;a&quot;,
                        title: &quot;#&quot;,
                        width: 100,
                        align: &quot;left&quot;,
                    },
                    {
                        field: &quot;name&quot;,
                        key: &quot;b&quot;,
                        title: &quot;Name&quot;,
                        width: 200,
                        align: &quot;left&quot;,
                    },
                    {
                        field: &quot;hobby&quot;,
                        key: &quot;c&quot;,
                        title: &quot;Hobby&quot;,
                        width: 300,
                        align: &quot;left&quot;,
                    },
                    {
                        field: &quot;address&quot;,
                        key: &quot;d&quot;,
                        title: &quot;Address&quot;,
                        width: &quot;&quot;,
                        align: &quot;left&quot;,
                    },
                ],
                tableData: [],
                remoteData: [],
                // pageing info by request
                pagingInfo: {
                    pageSize: 20,
                    totalPage: 500,
                    totalCount: 10000,
                },
                // scrolling event delay request event
                debounceTime: 150,
                debounceGetDataByPageIndex: null,
            };
        },
        methods: {
            initEmptyData() {
                let data = [];
                const totalCount = this.pagingInfo.totalCount;
                for (let i = 0; i &lt; totalCount; i++) {
                    data.push({
                        rowKey: &quot;prefix&quot; + i,
                        index: i,
                        name: &quot;&quot;,
                        hobby: &quot;&quot;,
                        address: &quot;&quot;,
                    });
                }

                this.tableData = data;
            },
            // get data by page index
            getDataByPageIndex(currentPageIndex, nextPageIndex) {
                const { remoteData, pagingInfo } = this;
                const { pageSize } = pagingInfo;

                const currentStartIndex = (currentPageIndex - 1) * pageSize;
                const nextStartIndex = (nextPageIndex - 1) * pageSize;

                if (
                    remoteData.find((x) =&gt; x.index === currentStartIndex) &amp;&amp;
                    remoteData.find((x) =&gt; x.index === nextStartIndex)
                ) {
                    return false;
                }

                // whether to request 2 pages of data at one time
                const isDouble = currentPageIndex !== nextPageIndex;

                this.getRemoteData(currentStartIndex, isDouble).then((resData) =&gt; {
                    if (Array.isArray(resData) &amp;&amp; resData.length) {
                        this.remoteData = this.remoteData.concat(resData);
                        resData.forEach((item) =&gt; {
                            this.tableData.splice(item.index, 1, item);
                        });
                    }
                });
            },
            // get remote data
            getRemoteData(startIndex, isDouble) {
                console.log(
                    `send request by ${
                        isDouble ? &quot;double&quot; : &quot;single&quot;
                    } page. start index:${startIndex}`,
                );
                const { pagingInfo } = this;
                const { pageSize, totalCount } = pagingInfo;

                return new Promise((resolve, reject) =&gt; {
                    // mock your remote server
                    const realPageSize = isDouble ? pageSize * 2 : pageSize;
                    let pageData = [];
                    setTimeout(() =&gt; {
                        for (let i = 0; i &lt; realPageSize; i++) {
                            const index = startIndex + i;

                            const dataItem = {
                                rowKey: &quot;prefix&quot; + index,
                                index: index,
                                name: &quot;name&quot; + index,
                                hobby: &quot;hobby&quot; + index,
                                address: &quot;address&quot; + index,
                            };
                            //
                            if (index &lt; totalCount) {
                                pageData.push(dataItem);
                            }
                        }
                        resolve(pageData);
                    }, 200);
                });
            },
            scrolling({
                startRowIndex,
                visibleStartIndex,
                visibleEndIndex,
                visibleAboveCount,
                visibleBelowCount,
            }) {
                const { pageSize } = this.pagingInfo;
                const currentPageIndex = Math.floor(visibleStartIndex / pageSize) + 1;
                const nextPageIndex = Math.floor(visibleEndIndex / pageSize) + 1;
                this.debounceGetDataByPageIndex(currentPageIndex, nextPageIndex);
            },
        },
        created() {
            this.initEmptyData();
            this.debounceGetDataByPageIndex = debounce(this.getDataByPageIndex, this.debounceTime);
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        import { debounce } from "lodash";
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('ve-table',{attrs:{"max-height":500,"virtual-scroll-option":_vm.virtualScrollOption,"columns":_vm.columns,"table-data":_vm.tableData,"row-key-field-name":"rowKey"}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                virtualScrollOption: {
                    enable: true,
                    scrolling: this.scrolling,
                },
                columns: [
                    {
                        field: "index",
                        key: "a",
                        title: "#",
                        width: 100,
                        align: "left",
                    },
                    {
                        field: "name",
                        key: "b",
                        title: "Name",
                        width: 200,
                        align: "left",
                    },
                    {
                        field: "hobby",
                        key: "c",
                        title: "Hobby",
                        width: 300,
                        align: "left",
                    },
                    {
                        field: "address",
                        key: "d",
                        title: "Address",
                        width: "",
                        align: "left",
                    },
                ],
                tableData: [],
                remoteData: [],
                // pageing info by request
                pagingInfo: {
                    pageSize: 20,
                    totalPage: 500,
                    totalCount: 10000,
                },
                // scrolling event delay request event
                debounceTime: 150,
                debounceGetDataByPageIndex: null,
            };
        },
        methods: {
            initEmptyData() {
                let data = [];
                const totalCount = this.pagingInfo.totalCount;
                for (let i = 0; i < totalCount; i++) {
                    data.push({
                        rowKey: "prefix" + i,
                        index: i,
                        name: "",
                        hobby: "",
                        address: "",
                    });
                }

                this.tableData = data;
            },
            // get data by page index
            getDataByPageIndex(currentPageIndex, nextPageIndex) {
                const { remoteData, pagingInfo } = this;
                const { pageSize } = pagingInfo;

                const currentStartIndex = (currentPageIndex - 1) * pageSize;
                const nextStartIndex = (nextPageIndex - 1) * pageSize;

                if (
                    remoteData.find((x) => x.index === currentStartIndex) &&
                    remoteData.find((x) => x.index === nextStartIndex)
                ) {
                    return false;
                }

                // whether to request 2 pages of data at one time
                const isDouble = currentPageIndex !== nextPageIndex;

                this.getRemoteData(currentStartIndex, isDouble).then((resData) => {
                    if (Array.isArray(resData) && resData.length) {
                        this.remoteData = this.remoteData.concat(resData);
                        resData.forEach((item) => {
                            this.tableData.splice(item.index, 1, item);
                        });
                    }
                });
            },
            // get remote data
            getRemoteData(startIndex, isDouble) {
                console.log(
                    `send request by ${
                        isDouble ? "double" : "single"
                    } page. start index:${startIndex}`,
                );
                const { pagingInfo } = this;
                const { pageSize, totalCount } = pagingInfo;

                return new Promise((resolve, reject) => {
                    // mock your remote server
                    const realPageSize = isDouble ? pageSize * 2 : pageSize;
                    let pageData = [];
                    setTimeout(() => {
                        for (let i = 0; i < realPageSize; i++) {
                            const index = startIndex + i;

                            const dataItem = {
                                rowKey: "prefix" + index,
                                index: index,
                                name: "name" + index,
                                hobby: "hobby" + index,
                                address: "address" + index,
                            };
                            //
                            if (index < totalCount) {
                                pageData.push(dataItem);
                            }
                        }
                        resolve(pageData);
                    }, 200);
                });
            },
            scrolling({
                startRowIndex,
                visibleStartIndex,
                visibleEndIndex,
                visibleAboveCount,
                visibleBelowCount,
            }) {
                const { pageSize } = this.pagingInfo;
                const currentPageIndex = Math.floor(visibleStartIndex / pageSize) + 1;
                const nextPageIndex = Math.floor(visibleEndIndex / pageSize) + 1;
                this.debounceGetDataByPageIndex(currentPageIndex, nextPageIndex);
            },
        },
        created() {
            this.initEmptyData();
            this.debounceGetDataByPageIndex = debounce(this.getDataByPageIndex, this.debounceTime);
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  